import http from "@/http-common";

/* eslint-disable */
class AgsDataService {
  getSerialNoByTextract(image: any): Promise<any> {
    return http.api.post("/getSerialNoAirbag", image)
  }
  getVinNoByTextract(image: any): Promise<any> {
    return http.api.post("/getVinNoAirbag", image)
  }
  postTieData(tieData: any): Promise<any> {
    return http.api.post("/postTieDataAirbag", tieData)
  }
  searchTieData(tieData: any): Promise<any> {
    return http.api.post("/searchTieData", tieData)
  }
  searchNGList(data: any): Promise<any> {
    return http.api.post("/searchNGList", data)
  }
}
export default new AgsDataService();
